import { FormFactorToggle } from './FormFactorToggle';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useSlot } from '../../components/sidebarSlot';
import { RunNav } from './RunNav';
import { SubmodelPicker } from './SubmodelPicker';
import { BlenderAddonButton } from './BlenderAddonButton';
import { IS_DEMO } from '../../apiBase';
import { SIDEBAR_FOOT_ID } from '../../components/sidebarSlot';

// THE OPEN DOCUMENT'S CONTROLS IN THE DESKTOP SIDEBAR, under the navigation: start a run,
// which run, then which submodel. One portal for all three, so their order is this file's
// and not whichever of several portals into the same box happened to mount first.
export function DocSidebar({ docId, disabled, submodelIdle, runControls }: {
  docId: string;
  disabled?: boolean;
  // The open phase does not read the submodel: its picker is greyed (see PhaseSection.submodel).
  submodelIdle?: boolean;
  // New run / Pause / Resume (RunControls), built by the viewer, which holds the run.
  runControls: ReactNode;
}) {
  const slot = useSlot();
  // AND THE RAIL'S BOTTOM: the Blender add-on, which belongs to the account rather than to any
  // phase. Not in the demo, which has no add-on to install.
  const foot = useSlot(SIDEBAR_FOOT_ID);
  return (
    <>
      {slot && createPortal(
        <>
          {runControls}
          <RunNav docId={docId} disabled={disabled} />
          <SubmodelPicker docId={docId} idle={submodelIdle} />
        </>,
        slot,
      )}
      {/* THE VIEWER'S SHAPE, under the language (see formFactor), then the add-on. */}
      {foot && createPortal(
        <div className="flex flex-col items-center gap-2">
          <FormFactorToggle />
          {!IS_DEMO && <BlenderAddonButton docId={docId} />}
        </div>,
        foot,
      )}
    </>
  );
}
